export default __webpack_public_path__ + "media/zurb/img/lab/playground/foundation-icon-fonts-3/svgs/fi-social-dropbox-272daf290f9eb80b93732d161331377b.svg";